exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ingredient + .ingredient {\n  margin-top: 25px;\n}\nsvg.icon {\n  cursor: pointer;\n}\n.uploadImg {\n  cursor: pointer;\n}\n.slide-enter-active, .slide-leave-active {\n  transition-duration: 0.3s;\n  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);\n}\n.slide-enter-active {\n  transition-duration: 0.3s;\n  transition-timing-function: ease-in;\n}\n.slide-enter-to, .slide-leave {\n  max-height: 100px;\n  overflow: hidden;\n}\n.slide-enter, .slide-leave-to {\n  overflow: hidden;\n  max-height: 0;\n}", ""]);

// exports
